module.exports = __webpack_public_path__ + "img/icon-store.62eaf859.svg";